<template>
    <div class="slide full" :style="`background-image: url(${slide.photo})`">
        <div class="white-bg">
            <div class="content" v-html="slide.details"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['photo', 'details', 'slide'],
    components: {},
    mounted() {}
}
</script>

<style scoped>
.full {
    overflow: hidden;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
}
.white-bg {
    width: 50%;
    min-height: 100%;
    margin-left: 50%;
    background: rgba(255,255,255,0.85);
    /* position: absolute; */
    right: 0;
    top: 0;
    bottom: 0;
    /* overflow-y: auto; */
    overscroll-behavior: contain;
}
.content {
    padding: 60px;
    color: #000000;
    text-align: left;
    line-height: 1.4;
    position: relative;
}


/* MEDIA QUERIES */
@media (max-width: 991px) {
    .white-bg {
        width: 100%;
        top: 20%;
        left: 0;
        margin-left: 0;
    }
}
@media (max-width: 575px) {
    .content {
        padding: 40px 40px 60px 60px;
    }
}
@media (max-width: 400px) {
    .content {
        padding: 40px 30px 40px 50px;
    }
}
</style>